// Predefined company tags for consistency
export const COMPANIES = {
  crunchyroll: { emoji: "🍊", name: "Crunchyroll", color: "#FF5E00" },
  apple: { emoji: "🍎", name: "Apple", color: "#555555" },
  panera: { emoji: "🥖", name: "Panera Bread", color: "#6B4423" },
  google: { emoji: "🔍", name: "Google", color: "#4285F4" },
  amazon: { emoji: "📦", name: "Amazon", color: "#FF9900" },
} as const;
